import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { authData } from "../../redux/auth/authSlice";
import { Skeleton } from "@material-ui/lab";
import config from "../../aws-exports";
import API from "@aws-amplify/api";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Box,
  Tabs,
  IconButton,
  CircularProgress,
  Backdrop,
} from "@mui/material";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import PostHeaderView from "../../components/SocialLearning/PostHeaderView";
import Paper from "@mui/material/Paper";
import Polling from "../../components/SocialLearning/Polling/Polling";
import Slider from "react-slick";
import { CardMedia } from "@mui/material";
import Button from "@mui/joy/Button";
import { awsSignIn } from "../../redux/auth/authSlice";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import BGImage from "../../assets/SLbg.png";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import SearchHeader from "../../components/SocialLearning/SearchHeader";
import NewSVG from "../../assets/newBlue 1.png";
import PopularSVG from "../../assets/popularGreen 1.png";
import CoinsSVG from "../../assets/My Coins.png";
import { ReactComponent as EditSVG } from "../../assets/svg/solid_edit.svg";
import PostFooterView from "../../components/SocialLearning/PostFooterView";
import { callAPI } from "../../api/api";
import { useHistory } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import soon from "../../../src/assets/soon.gif";
import Person2Icon from "@mui/icons-material/Person2";
function MyPost() {
  const userDetails = useSelector(authData);
  const useStyles = makeStyles((themeStyle) => ({
    root: {},
    mainLayout: {
      margin: "0rem 12rem",
      "@media (max-width: 900px)": {
        margin: "0rem",
      },
    },
    mainContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "start",
      "@media (max-width: 550px)": {
        marginBottom: "1rem",
      },
    },
    loaderSkeleton: {
      width: "500px",
      height: "5rem",
      "@media (max-width: 750px)": {
        width: "200px",
      },
    },
    loaderSkeletonSlider: {
      width: "100%",
      height: "45rem !important",
    },

    mainSlider: {
      margin: "3rem 0rem",
      height: "15rem",
      "& > button:before": {
        color:
          userDetails.themeDark === "dark"
            ? "white!important"
            : "gray!important",
        fontSize: "3rem",
      },
      "& > ul > li > button:before": {
        color:
          userDetails.themeDark === "dark"
            ? "white!important"
            : "gray!important",
        fontSize: "1rem",
      },
      "& > div > div": {
        margin: "unset",
        width: "100%!important",
        "& > div": {
          marginRight: "5rem!important",
        },
      },
    },
    postSlider: {
      marginBottom: "3rem",
    },
    centered: {
      position: "absolute",
      bottom: "20%",
      left: "5rem",
      color: "white",
      width: "23rem",
      display: "grid",
      gap: "0.5rem",
    },
    sliderData: {
      position: "relative",
    },
    buttonPrimary: {
      backgroundColor: "var(--color-button-background)!important",
      fontSize: "1.7rem!important",
      textTransform: "capitalize!important",
    },
    sliderImage: {
      width: "25rem",
      filter: "brightness(0.8)",
      borderRadius: "1rem",
      position: "relative",
      left: "3rem",
    },
    actionButton: {
      backgroundColor:
        userDetails.themeDark === "dark"
          ? "#2c2e31!important"
          : "#EBEBEB!important",
      borderRadius: "2rem!important",
      boxShadow: "0px 0px 3px 1px rgba(102, 102, 102, 0.3)",
      margin: "1rem!important",
      fontSize: "1.5rem!important",
      textTransform: "capitalize!important",
      color:
        userDetails.themeDark === "dark"
          ? "white!important"
          : "black !important",
      gap: "1rem",
      padding: "0.5rem 1rem!important",
      border:
        userDetails.themeDark === "dark"
          ? "1px solid gray!important"
          : "1px solid lightgray!important",
      "&:active": {
        color: "var(--color-button-background) !important",
        borderRadius: "1.5rem !important",
        fontSize: "1.5rem !important",
        backgroundColor: "aliceblue !important",
        gap: "1rem !important",
        margin: "1rem !important",
        boxShadow: "0px 0px 3px 1px rgba(102, 102, 102, 0.3) !important",
      },
      "& > svg": {
        fontSize: "3.5rem",
        color: userDetails.themeDark === "dark" ? "white!important" : "black",
        "&:active": {
          color: "var(--color-button-background)!important",
        },
      },
    },
    activeButton: {
      color:
        userDetails.themeDark === "dark"
          ? "white!important"
          : "var(--color-button-background) !important",
      borderRadius: "1.5rem !important",
      fontSize: "1.5rem !important",
      backgroundColor:
        userDetails.themeDark === "dark" ? "#d0d0d094!important" : "white",
      gap: "1rem !important",
      margin: "1rem !important",
      boxShadow: "0px 0px 3px 1px rgba(102, 102, 102, 0.3) !important",
      "& > svg": {
        fill:
          userDetails.themeDark === "dark"
            ? "white!important"
            : "var(--color-button-background) !important",
      },
    },
    actionButtonTag: {
      backgroundColor: "gray!important",
      borderRadius: "3rem!important",
      padding: "0px 10px!important",
      fontSize: "1rem!important",
      textTransform: "capitalize!important",
      color: "white!important",
      "&:active": {
        color: "var(--color-button-background)!important",
      },
    },
    actionButtonFollow: {
      borderRadius: "3rem!important",
      border: "2px solid!important",
      borderColor: "var(--color-button-background)!important",
      backgroundColor: "transparent!important",
      margin: "0!important",
      padding: "0px 10px!important",
      fontSize: "1.5rem!important",
      textTransform: "capitalize!important",
      "&:active": {
        color: "var(--color-button-background)!important",
      },
    },
    footerActiveButton: {
      color: "var(--color-button-background) !important",
      borderRadius: "1.5rem !important",
      fontSize: "1.5rem !important",
      backgroundColor: "transparent!important",
      gap: "1rem !important",
      "& > svg": {
        fill:
          userDetails.themeDark === "dark"
            ? "white"
            : "var(--color-button-background)",
        width: "3rem",
      },
    },
    myPostButton: {
      display: "flex!important",
      justifyContent: "space-between!important",
      margin: "1.7rem 0rem!important",
      fontSize: "1.5rem!important",
      textTransform: "capitalize!important",
      color:
        userDetails.themeDark === "dark"
          ? "white!important"
          : "black!important",
      width: "100%",
      "& > div > svg:first-child": {
        fontSize: "3rem",
        color:
          userDetails.themeDark === "dark"
            ? "white!important"
            : "black!important",
      },
      "& > svg": {
        fontSize: "3rem",
        color: "var(--color-button-background)!important",
      },
    },
    sliderImageFull: {
      width: "100%",
      objectFit: "contain",
      height: "315px",
      cursor: "pointer",
    },
    firstTrend: {
      color: "black!important",
      padding: "1rem",
      backgroundColor: "#EBEBEB",
    },
    showMoreSection: {
      padding: "1rem",
      backgroundColor:
        userDetails.themeDark === "dark" ? "transparent" : "#EBEBEB",
      display: "flex",
      "& > a": {
        textDecoration: "none",
        color: "var(--color-button-background)!important",
      },
    },
    socialIcons: {
      fontSize: "2.5rem!important",
      color:
        userDetails.themeDark === "dark"
          ? "white!important"
          : "black!important",
    },
    leftPaperBottom: {
      width: "100%",
      boxShadow:
        userDetails.themeDark === "dark"
          ? "none!important"
          : "0px 0px 0px 1px rgba(102, 102, 102, 0.3)!important",
      margin: "1rem 0!important",
      padding: "2rem",
    },
    rightPaper: {
      width: "100%",
      margin: "1rem 0rem!important",
      boxShadow:
        userDetails.themeDark === "dark"
          ? "none!important"
          : "0px 0px 0px 1px rgba(102, 102, 102, 0.3)!important",
    },
    userMenuItems: {
      display: "flex",
      justifyContent: "space-between",
      margin: "2rem 0 0!important",
      flexWrap: "wrap",
    },
    userMenuButton: {
      fontSize: "1.4rem !important",
      textTransform: "capitalize !important",
      gap: "0.5rem",
      color: "gray",
    },
    secondGridResponsive: {
      padding: "1rem 0rem 1rem 1rem",
      "@media (max-width: 900px)": {
        padding: "1rem 1rem 1rem 0rem!important",
      },
    },
    backdrop: {
      zIndex: themeStyle.zIndex.drawer + 1,
      color: "#fff",
    },
    sendButton: {
      backgroundColor: "var(--color-button-background)",
      color: "white",
      borderRadius: "5px",
      fontSize: "2rem!important",
      padding: "4px",
      width: "5.5rem!important",
      height: "4rem!important",
    },
    actionButtonsSections: {
      display: "flex",
      gap: "3rem",
      padding: "1rem 2rem",
      width: "100%",
      flexWrap: "wrap",
      "& > button": {
        textTransform: "capitalize",
        fontSize: "1.4rem!important",
        gap: "10px!important",
        color:
          userDetails.themeDark === "dark"
            ? "white!important"
            : "gray!important",
      },
      "& > button > svg": {
        width: "3.5rem",
        height: "3.5rem",
      },
    },
    personIcon: {
      fontSize: "3rem!important",
      boxShadow: "0px 0px 3px 1px rgba(102, 102, 102, 0.3) !important",
      borderRadius: "3rem",
      padding: "4px",
    },
    formStyle: {
      width: "80%",
      display: "grid",
      margin: "1rem 0",
      border: "2px solid #E7E7E7",
      borderRadius: "5px",
      "& > h4": {
        padding: "1rem 3rem",
        backgroundColor: "#F2F2F2",
      },
    },
    saveIconsSVG: {
      width: "3rem",
      height: "3rem",
      fill: userDetails.themeDark === "dark" ? "white " : "black",
    },
  }));
  const [offset, setOffset] = useState(0);
  const [postLoad, setPostLoad] = useState(false);
  const classes = useStyles();
  const [value, setValue] = React.useState("1");
  const history = useHistory();
  const dispatch = useDispatch();
  const fetchPopularPosts = async () => {
    try {
      if (userDetails === 0) {
        window.location.href = config.aws_cloudfront_lurl;
      }
      const bodyParam = {
        body: {
          schema: config.schema,
          offset: offset,
          limit: 500,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: userDetails?.accessToken,
        },
      };

      const response = await API.get(
        config.aws_cloud_logic_custom_name,
        `/getmypostpopular?ur_id=${userDetails?.uData?.ur_id}&schema=${config.schema}&offset=${offset}&limit=50&oid=${config.aws_org_id}`,
        bodyParam
      );

      return response;
    } catch (err) {
      let obj = {};
      obj.status = 400;
      obj.data = err;
      return obj;
    }
  };
  const fetchNewPosts = async () => {
    try {
      let obj = {};
      obj.method = "get";
      obj.apiName = `/gettimelinenewposts?ur_id=${userDetails?.uData?.ur_id}&schema=${config.schema}&offset=${offset}&limit=50&oid=${config.aws_org_id}`;
      obj.body = {};
      obj.body.offset = offset;
      obj.body.limit = 300;
      const res = await callAPI(obj, userDetails);
      return res;
    } catch (err) {
      let obj = {};
      obj.status = 400;
      obj.data = err;
      return obj;
    }
  };
  const callAPIFunction = async (Type) => {
    try {
      let obj = {};
      obj.method = "get";
      obj.body = {};
      obj.body.ur_id = userDetails?.uData?.ur_id;
      obj.body.schema = config.schema;
      obj.body.offset = offset;
      obj.body.limit = 50;
      if (Type === "2") {
        obj.apiName = `/getmypost`;
      } else if (Type === "3") {
        obj.apiName = `/getmycomments`;
      } else if (Type === "4") {
        obj.apiName = `/getmysavedposts`;
      } else if (Type === "5") {
        obj.apiName = "/getmymostlikedposts";
      }
      const res = await callAPI(obj, userDetails);
      return res;
    } catch (err) {
      let obj = {};
      obj.status = 400;
      obj.body = [];
      return obj;
    }
  };
  const settings1 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
  };
  const { isLoading, error, refetch: hotRefeth, data } = useQuery({
    queryKey: ["getPopularPosts", userDetails?.uData?.ur_id],
    queryFn: fetchPopularPosts,
  });
  const { isLoading: load, error: err, data: newData, refetch } = useQuery({
    queryKey: ["getNewPosts", userDetails?.uData?.ur_id],
    queryFn: fetchNewPosts,
  });
  const handleChange1 = async (event, newValue) => {
    setPostLoad(true);
    setMainLoader(true);
    let res = await callAPIFunction(newValue);
    setPostData(res.body);
    setPostLoad(false);
    setMainLoader(false);
    setValue(newValue);
  };

  const [value1, setValue1] = React.useState("1");
  const [postData, setPostData] = React.useState([]);
  const [mainLoader, setMainLoader] = useState(false);
  const handleChange2 = (event, newValue) => {
    setValue1(newValue);
  };
  const handleSaveSuccess = () => {
    refetch();  
  };
  
  const datareturn = () => {
    return postData?.map((row, ind) => (
      <Paper elevation={3} className={classes.leftPaper}>
        <div>
          <h2 style={{ margin: "1rem 0rem" }}>{row.post_title}</h2>
        </div>
        <div
          style={{
            display: "block",
            margin: "2rem 0rem",
            textDecoration: "none",
          }}
        >
          <p style={{ fontSize: "1.5rem" }}>{row.content}</p>
        </div>
        <PostFooterView
          row={row}
          classes={classes}
          userDetails={userDetails}
          hotRefeth={hotRefeth}
          history={history}
          setMainLoader={setMainLoader}
          handleSaveSuccess={handleSaveSuccess}
        />
      </Paper>
    ));
  };
  return (
    <>
      <SearchHeader />
      <div className={classes.mainLayout}>
        {mainLoader ? (
          <Backdrop className={classes.backdrop} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        ) : null}
        {isLoading ? (
          <Skeleton className={classes.loaderSkeletonSlider} />
        ) : (
          <div className={classes.root}>
            <div>
              <Box sx={{ width: "100%", typography: "body1" }}>
                <TabContext value={value}>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <TabList
                      onChange={handleChange1}
                      aria-label="lab API tabs example"
                      variant="fullWidth"
                    >
                      <Tab
                        label="Overview"
                        value="1"
                        className={classes.tabButton}
                      />
                      <Tab
                        label="Saved"
                        value="4"
                        className={classes.tabButton}
                      />
                      <Tab
                        label="Most Liked"
                        value="5"
                        className={classes.tabButton}
                      />
                      <Tab
                        label="Reach"
                        value="7"
                        className={classes.tabButton}
                      />
                    </TabList>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    style={{ margin: "0", padding: "0" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={8}
                      lg={8}
                      style={{ padding: "1rem 1rem 1rem 0rem" }}
                    >
                      <TabPanel value="1">
                        <div className={classes.mainHeader}>
                          <h3 style={{ fontWeight: "600" }}>
                            {isLoading ? (
                              <Skeleton className={classes.loaderSkeleton} />
                            ) : (
                              <>Your post</>
                            )}
                          </h3>
                        </div>
                        <Paper elevation={3} style={{ boxShadow: "none" }}>
                          <Box sx={{ width: "100%", typography: "body1" }}>
                            <TabContext value={value1}>
                              <Box
                                sx={{
                                  borderBottom: 1,
                                  backgroundColor: "transparent",
                                  borderColor: "divider",
                                  overflow: "hidden!important",
                                  height: "7.4rem",
                                  "& > div": {
                                    "@media (max-width: 768px)": {
                                      width: "56rem",
                                    },
                                    "& > div > div > .Mui-selected": {
                                      color:
                                        "var(--color-button-background)!important",
                                    },
                                  },
                                }}
                                className={classes.leftPaperTop}
                              >
                                <Tabs
                                  value={value1}
                                  onChange={handleChange2}
                                  aria-label="basic tabs example"
                                  indicatorColor="primary"
                                  textColor="inherit"
                                  variant="fullWidth"
                                >
                                  <Tab
                                    label={`${userDetails?.languagejson
                                      ?.Gamification?.New || "New"}`}
                                    value="1"
                                    className={classes.tabButton1}
                                    icon={
                                      <img
                                        src={NewSVG}
                                        alt="Balance Available Coins"
                                        title="Balance Available Coins"
                                        className={classes.tabIcon}
                                      />
                                    }
                                  />
                                  <Tab
                                    label={`${userDetails?.languagejson
                                      ?.Gamification?.Popular || "Popular"}`}
                                    value="2"
                                    className={classes.tabButton1}
                                    icon={
                                      <img
                                        src={PopularSVG}
                                        alt="Balance Available Coins"
                                        title="Balance Available Coins"
                                        className={classes.tabIcon}
                                      />
                                    }
                                  />
                                </Tabs>
                              </Box>

                              <TabPanel value="1" style={{ padding: "1rem 0" }}>
                                {!load &&
                                  (newData ? newData.body : data.body).map(
                                    (row, ind) => (
                                      <Paper
                                        elevation={3}
                                        key={ind}
                                        className={classes.leftPaperBottom}
                                      >
                                        <PostHeaderView
                                          row={row}
                                          classes={classes}
                                          ind={ind}
                                          userDetails={userDetails}
                                          hotRefeth={hotRefeth}
                                          refetch={refetch}
                                          setMainLoader={setMainLoader}
                                        />
                                        <p
                                          style={{
                                            marginBottom: "2rem",
                                            overflowWrap: "break-word",
                                          }}
                                        >
                                          {row.content}
                                        </p>
                                        {row.posttypeid === 1 && (
                                          <div className={classes.formStyle}>
                                            <Polling
                                              row={row}
                                              ind={ind}
                                              userDetails={userDetails}
                                              refetch={refetch}
                                              setMainLoader={setMainLoader}
                                            />
                                          </div>
                                        )}
                                        {row.json_attachment && (
                                          <Slider
                                            className={classes.postSlider}
                                            {...settings1}
                                          >
                                            {row.json_attachment.map((item) => (
                                              <div
                                                className={classes.sliderData}
                                              >
                                                {item.filetype?.includes(
                                                  "pdf"
                                                ) && (
                                                  <CardMedia
                                                    alt="GeeksforGeeks"
                                                    component="iframe"
                                                    width="100%"
                                                    height="315px"
                                                    title={item.filename}
                                                    allowfullscreen
                                                    src={
                                                      item.ourl +
                                                      "#navpanes=0&page=1&view=FitH,top"
                                                    }
                                                    className={
                                                      classes.documentSection
                                                    }
                                                  />
                                                )}
                                                {item.filetype?.includes(
                                                  "video"
                                                ) && (
                                                  <video
                                                    width="inherit"
                                                    height="300"
                                                    controls
                                                  >
                                                    <source
                                                      src={item.ourl}
                                                      type="video/mp4"
                                                    />
                                                    Your browser does not
                                                    support the video tag.
                                                  </video>
                                                )}
                                                {item.filetype?.includes(
                                                  "image"
                                                ) && (
                                                  <img
                                                    className={
                                                      classes.sliderImageFull
                                                    }
                                                    src={item.ourl}
                                                    alt=""
                                                    onClick={() => {
                                                      let udata = {
                                                        ...userDetails,
                                                      };
                                                      udata.postDataByid = row;
                                                      dispatch(
                                                        awsSignIn(udata)
                                                      );
                                                      window.location.href =
                                                        "#/social-learning/InDetails";
                                                    }}
                                                  />
                                                )}
                                              </div>
                                            ))}
                                          </Slider>
                                        )}
                                        <Paper
                                          component="form"
                                          sx={{
                                            p: "2px 4px",
                                            display: "flex",
                                            alignItems: "center",
                                            borderRadius: "4px",
                                            boxShadow:
                                              "0px 0px 3px 1px rgba(102, 102, 102, 0.3)",
                                            color: "gray",
                                            fontSize: "1.5rem",
                                          }}
                                        >
                                          <Button
                                            onClick={() => {
                                              let udata = { ...userDetails };
                                              udata.postDataByid = row;
                                              dispatch(awsSignIn(udata));
                                              history.push(
                                                "/social-learning/InDetails"
                                              );
                                            }}
                                            style={{
                                              borderRadius: "4px",
                                              color: "gray",
                                              fontWeight: "400",
                                              backgroundColor: "white",
                                              fontSize: "1.5rem",
                                              textTransform: "capitalize",
                                              justifyContent: "left",
                                              width: "100%",
                                            }}
                                          >
                                            <IconButton
                                              sx={{ p: "10px" }}
                                              aria-label="menu"
                                            >
                                              <Person2Icon
                                                style={{
                                                  fontSize: "2.5rem",
                                                  color: "gray",
                                                }}
                                              />
                                            </IconButton>
                                            Write your comment...
                                          </Button>
                                        </Paper>

                                        <PostFooterView
                                          row={row}
                                          classes={classes}
                                          userDetails={userDetails}
                                          hotRefeth={hotRefeth}
                                          history={history}
                                          setMainLoader={setMainLoader}
                                          handleSaveSuccess={handleSaveSuccess}
                                        />
                                      </Paper>
                                    )
                                  )}
                                {load && (
                                  <Skeleton
                                    className={classes.loaderSkeletonSlider}
                                  />
                                )}
                              </TabPanel>
                              <TabPanel value="2" style={{ padding: "1rem 0" }}>
                                {!isLoading &&
                                  data?.body?.map((row, ind) => (
                                    <Paper
                                      elevation={3}
                                      className={classes.leftPaper}
                                    >
                                      <PostHeaderView
                                        row={row}
                                        classes={classes}
                                        ind={ind}
                                        userDetails={userDetails}
                                      />
                                      {row.posttypeid === 1 && (
                                        <div className={classes.formStyle}>
                                          <Polling
                                            row={row}
                                            ind={ind}
                                            userDetails={userDetails}
                                            refetch={refetch}
                                            setMainLoader={setMainLoader}
                                          />
                                        </div>
                                      )}
                                      <PostFooterView
                                        row={row}
                                        classes={classes}
                                        userDetails={userDetails}
                                        hotRefeth={hotRefeth}
                                        history={history}
                                        setMainLoader={setMainLoader}
                                        handleSaveSuccess={handleSaveSuccess}
                                      />
                                    </Paper>
                                  ))}
                                {isLoading && (
                                  <Skeleton
                                    className={classes.loaderSkeletonSlider}
                                  />
                                )}
                              </TabPanel>
                            </TabContext>
                          </Box>
                        </Paper>
                      </TabPanel>

                      <TabPanel value="2">
                        {!postLoad && datareturn()}
                        {!postLoad && postData && postData.length === 0 && (
                          <>No Data</>
                        )}
                      </TabPanel>

                      <TabPanel value="3">
                        {!postLoad && datareturn()}
                        {!postLoad && postData && postData.length === 0 && (
                          <>No Data</>
                        )}
                      </TabPanel>

                      <TabPanel value="4" style={{ padding: "1rem 0" }}>
                        {!postLoad && newData && newData.body?.length > 0 ? (
                          newData.body
                            .filter((row) => row.usersavedpost)
                            .map((row, ind) => (
                              <Paper
                                elevation={3}
                                key={ind}
                                className={classes.leftPaperBottom}
                              >
                                <PostHeaderView
                                  row={row}
                                  classes={classes}
                                  ind={ind}
                                  userDetails={userDetails}
                                  hotRefeth={hotRefeth}
                                  refetch={refetch}
                                  setMainLoader={setMainLoader}
                                />
                                <p
                                  style={{
                                    marginBottom: "2rem",
                                    overflowWrap: "break-word",
                                  }}
                                >
                                  {row.content}
                                </p>
                                {row.posttypeid === 1 && (
                                  <div className={classes.formStyle}>
                                    <Polling
                                      row={row}
                                      ind={ind}
                                      userDetails={userDetails}
                                      refetch={refetch}
                                      setMainLoader={setMainLoader}
                                    />
                                  </div>
                                )}
                                {row.json_attachment && (
                                  <Slider
                                    className={classes.postSlider}
                                    {...settings1}
                                  >
                                    {row.json_attachment.map((item, index) => (
                                      <div
                                        className={classes.sliderData}
                                        key={index}
                                      >
                                        {item.filetype?.includes("pdf") && (
                                          <CardMedia
                                            alt={item.filename}
                                            component="iframe"
                                            width="100%"
                                            height="315px"
                                            title={item.filename}
                                            allowFullScreen
                                            src={
                                              item.ourl +
                                              "#navpanes=0&page=1&view=FitH,top"
                                            }
                                            className={classes.documentSection}
                                          />
                                        )}
                                        {item.filetype?.includes("video") && (
                                          <video
                                            width="inherit"
                                            height="300"
                                            controls
                                          >
                                            <source
                                              src={item.ourl}
                                              type="video/mp4"
                                            />
                                            Your browser does not support the
                                            video tag.
                                          </video>
                                        )}
                                        {item.filetype?.includes("image") && (
                                          <img
                                            className={classes.sliderImageFull}
                                            src={item.ourl}
                                            alt={item.filename || "Image"}
                                            onClick={() => {
                                              let udata = { ...userDetails };
                                              udata.postDataByid = row;
                                              dispatch(awsSignIn(udata));
                                              window.location.href =
                                                "#/social-learning/InDetails";
                                            }}
                                          />
                                        )}
                                      </div>
                                    ))}
                                  </Slider>
                                )}

                                <Paper
                                  component="form"
                                  sx={{
                                    p: "2px 4px",
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: "4px",
                                    boxShadow:
                                      "0px 0px 3px 1px rgba(102, 102, 102, 0.3)",
                                    color: "gray",
                                    fontSize: "1.5rem",
                                  }}
                                >
                                  <Button
                                    onClick={() => {
                                      let udata = { ...userDetails };
                                      udata.postDataByid = row;
                                      dispatch(awsSignIn(udata));
                                      history.push(
                                        "/social-learning/InDetails"
                                      );
                                    }}
                                    style={{
                                      borderRadius: "4px",
                                      color: "gray",
                                      fontWeight: "400",
                                      backgroundColor: "white",
                                      fontSize: "1.5rem",
                                      textTransform: "capitalize",
                                      justifyContent: "left",
                                      width: "100%",
                                    }}
                                  >
                                    <IconButton
                                      sx={{ p: "10px" }}
                                      aria-label="menu"
                                    >
                                      <Person2Icon
                                        style={{
                                          fontSize: "2.5rem",
                                          color: "gray",
                                        }}
                                      />
                                    </IconButton>
                                    Write your comment...
                                  </Button>
                                </Paper>

                                <PostFooterView
                                  row={row}
                                  classes={classes}
                                  userDetails={userDetails}
                                  hotRefeth={hotRefeth}
                                  history={history}
                                  setMainLoader={setMainLoader}
                                  handleSaveSuccess={handleSaveSuccess} 
                                />
                              </Paper>
                            ))
                        ) : (
                          <>No Data</>
                        )}
                        {postLoad && (
                          <Skeleton className={classes.loaderSkeletonSlider} />
                        )}
                      </TabPanel>

                      <TabPanel value="5">
                        <div>
                        <img src={soon} alt="comeing soon" width="500" height="400"/>
                        </div>
                      </TabPanel>

                      <TabPanel value="6">
                        <div className={classes.mainHeader}>
                          <h3 style={{ fontWeight: "600" }}>
                            {isLoading ? (
                              <Skeleton className={classes.loaderSkeleton} />
                            ) : (
                              <>Your Q&A</>
                            )}
                          </h3>
                        </div>
                        <Paper elevation={3} className={classes.leftPaperTop}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "1rem",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="40"
                              height="40"
                              viewBox="0 0 50 50"
                            >
                              <defs>
                                <linearGradient
                                  id="linear-gradient"
                                  y1="0.5"
                                  x2="1"
                                  y2="0.5"
                                  gradientUnits="objectBoundingBox"
                                >
                                  <stop offset="0" stop-color="#47a3e1" />
                                  <stop offset="1" stop-color="#005db6" />
                                </linearGradient>
                                <clipPath id="clip-New">
                                  <rect width="50" height="50" />
                                </clipPath>
                              </defs>
                              <g id="New" clip-path="url(#clip-New)">
                                <g
                                  id="Group_786"
                                  data-name="Group 786"
                                  transform="translate(-4.321 -4.002)"
                                >
                                  <path
                                    id="Path_159"
                                    data-name="Path 159"
                                    d="M50.024,28.689l2.3-7.089a.875.875,0,0,0-.317-.979l-6.031-4.382-2.3-7.08a.882.882,0,0,0-.838-.608H35.387L29.365,4.168a.9.9,0,0,0-1.04,0L22.3,8.55H14.852a.882.882,0,0,0-.838.608l-2.3,7.08L5.682,20.621a.875.875,0,0,0-.317.979l2.3,7.089-2.3,7.089a.875.875,0,0,0,.317.979l6.031,4.382,2.3,7.08a.882.882,0,0,0,.838.608H22.3l6.022,4.382a.887.887,0,0,0,1.04,0l6.022-4.382h7.451a.882.882,0,0,0,.838-.608l2.3-7.08,6.031-4.382a.875.875,0,0,0,.317-.979Zm-3.765,0A17.434,17.434,0,0,1,28.845,46.1c-23.1-.957-23.1-33.875,0-34.828A17.434,17.434,0,0,1,46.259,28.689ZM28.845,13.038A15.666,15.666,0,0,0,13.194,28.689c.856,20.763,30.448,20.758,31.3,0A15.666,15.666,0,0,0,28.845,13.038Z"
                                    transform="translate(0 0)"
                                    fill="url(#linear-gradient)"
                                  />
                                </g>
                              </g>
                            </svg>
                            <h3>New</h3>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "1rem",
                            }}
                          >
                            <svg
                              width="40"
                              height="40"
                              viewBox="0 0 50 50"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_627_11)">
                                <mask
                                  id="mask0_627_11"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="50"
                                  height="50"
                                >
                                  <path d="M50 0H0V50H50V0Z" fill="white" />
                                </mask>
                                <g mask="url(#mask0_627_11)">
                                  <path
                                    d="M25 48C37.7025 48 48 37.7025 48 25C48 12.2975 37.7025 2 25 2C12.2975 2 2 12.2975 2 25C2 37.7025 12.2975 48 25 48Z"
                                    fill="url(#paint0_linear_627_11)"
                                  />
                                  <path
                                    d="M14.0249 32.185C13.7747 32.184 13.528 32.1254 13.3039 32.0139C13.0193 31.8816 12.7851 31.6609 12.6361 31.3846C12.4871 31.1084 12.4313 30.7915 12.4769 30.481C12.5367 30.097 12.7058 29.7384 12.9639 29.448C15.4269 26.948 17.8939 24.4879 19.7639 22.6279C19.9122 22.471 20.0903 22.3453 20.2877 22.2581C20.4852 22.1708 20.6981 22.1239 20.9139 22.1199C21.1428 22.1256 21.3682 22.177 21.5768 22.2711C21.7855 22.3652 21.9732 22.5001 22.1289 22.668L26.3669 26.9059L32.1379 21.1349H31.5549C30.8149 21.1349 29.7999 21.126 29.2189 21.121C29.0122 21.1298 28.8058 21.0957 28.6129 21.0209C28.4199 20.9461 28.2445 20.8322 28.0977 20.6864C27.9509 20.5405 27.8359 20.3658 27.7598 20.1734C27.6838 19.9809 27.6484 19.7748 27.6559 19.5679C27.6507 19.3602 27.6865 19.1534 27.7613 18.9595C27.8362 18.7656 27.9485 18.5884 28.0919 18.4379C28.2387 18.2949 28.4123 18.1823 28.6028 18.1068C28.7934 18.0313 28.997 17.9943 29.2019 17.998C30.3739 17.998 31.5469 17.9919 32.6759 17.9919C33.8529 17.9919 35.0259 17.992 36.1629 17.998C36.3625 17.9903 36.5615 18.0234 36.7478 18.0954C36.9341 18.1673 37.1038 18.2765 37.2465 18.4162C37.3891 18.556 37.5018 18.7234 37.5775 18.9082C37.6532 19.093 37.6905 19.2913 37.6869 19.491C37.7029 21.891 37.7019 24.27 37.6869 26.545C37.6886 26.747 37.6489 26.9472 37.5703 27.1333C37.4917 27.3194 37.3759 27.4875 37.23 27.6273C37.0841 27.767 36.9111 27.8754 36.7218 27.9459C36.5324 28.0163 36.3307 28.0473 36.1289 28.037H36.1109C35.9082 28.0431 35.7063 28.0079 35.5176 27.9334C35.3289 27.8589 35.1574 27.7468 35.0136 27.6037C34.8697 27.4607 34.7565 27.2899 34.6809 27.1016C34.6053 26.9134 34.5689 26.7117 34.5739 26.509C34.5629 25.809 34.5649 25.1 34.5679 24.409V23.327C34.5449 23.347 34.5249 23.3669 34.5049 23.3869C32.5536 25.3469 30.6033 27.3073 28.6539 29.2679L27.8419 30.08C27.6701 30.2879 27.4585 30.4595 27.2194 30.5845C26.9804 30.7095 26.7188 30.7855 26.4499 30.808C26.186 30.7874 25.9289 30.7138 25.694 30.5916C25.4591 30.4695 25.2513 30.3012 25.0829 30.097L20.9109 25.9259L20.5729 26.2699C20.2119 26.6309 19.8679 26.9699 19.5339 27.3049L17.9669 28.8819C17.0669 29.7909 16.1329 30.731 15.2119 31.653C15.0595 31.8163 14.876 31.9474 14.6721 32.0388C14.4683 32.1302 14.2482 32.1799 14.0249 32.185Z"
                                    fill="white"
                                  />
                                </g>
                              </g>
                              <defs>
                                <linearGradient
                                  id="paint0_linear_627_11"
                                  x1="25"
                                  y1="2"
                                  x2="34.108"
                                  y2="50.622"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stop-color="#00B123" />
                                  <stop offset="1" stop-color="#00841A" />
                                </linearGradient>
                                <clipPath id="clip0_627_11">
                                  <rect width="50" height="50" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                            <h3>Popular</h3>
                          </div>
                        </Paper>

                        <Paper elevation={3} className={classes.leftPaper}>
                          <div>
                            <h2 style={{ margin: "1rem 0rem" }}>
                              Question Heading here
                            </h2>
                          </div>
                          <div
                            style={{
                              display: "block",
                              margin: "2rem 0rem",
                              textDecoration: "none",
                            }}
                          >
                            <p
                              style={{ fontSize: "1.5rem", fontWeight: "700" }}
                            >
                              2 answers
                            </p>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              margin: "2rem 0 0",
                            }}
                          >
                            <Button
                              style={{
                                fontSize: "1.4rem",
                                textTransform: "capitalize",
                                gap: "0.5rem",
                                color: "gray",
                                backgroundColor: "transparent",
                              }}
                            >
                              <FavoriteBorderOutlinedIcon
                                className={classes.socialIcons}
                              />
                              10k
                            </Button>
                            <Button
                              style={{
                                fontSize: "1.4rem",
                                textTransform: "capitalize",
                                gap: "0.5rem",
                                color: "gray",
                                backgroundColor: "transparent",
                              }}
                            >
                              <ChatBubbleOutlineOutlinedIcon
                                className={classes.socialIcons}
                              />
                              1k comm
                            </Button>
                            <Button
                              style={{
                                fontSize: "1.4rem",
                                textTransform: "capitalize",
                                gap: "0.5rem",
                                color: "gray",
                                backgroundColor: "transparent",
                              }}
                            >
                              <ShareOutlinedIcon
                                className={classes.socialIcons}
                              />
                              Share
                            </Button>
                            <Button
                              style={{
                                fontSize: "1.4rem",
                                textTransform: "capitalize",
                                gap: "0.5rem",
                                color: "gray",
                                backgroundColor: "transparent",
                              }}
                            >
                              <SaveOutlinedIcon
                                className={classes.socialIcons}
                              />
                              Save
                            </Button>
                            <Button style={{ backgroundColor: "transparent" }}>
                              <MoreHorizOutlinedIcon
                                className={classes.socialIcons}
                              />
                            </Button>
                          </div>
                        </Paper>
                        <Paper elevation={3} className={classes.leftPaper}>
                          <div>
                            <h2 style={{ margin: "1rem 0rem" }}>
                              Question Heading here
                            </h2>
                          </div>
                          <div
                            style={{
                              display: "block",
                              margin: "2rem 0rem",
                              textDecoration: "none",
                            }}
                          >
                            <p
                              style={{ fontSize: "1.5rem", fontWeight: "700" }}
                            >
                              No answers yet
                            </p>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              margin: "2rem 0 0",
                            }}
                          >
                            <Button
                              style={{
                                fontSize: "1.4rem",
                                textTransform: "capitalize",
                                gap: "0.5rem",
                                color: "gray",
                                backgroundColor: "transparent",
                              }}
                            >
                              <FavoriteBorderOutlinedIcon
                                className={classes.socialIcons}
                              />
                              10k
                            </Button>
                            <Button
                              style={{
                                fontSize: "1.4rem",
                                textTransform: "capitalize",
                                gap: "0.5rem",
                                color: "gray",
                                backgroundColor: "transparent",
                              }}
                            >
                              <ChatBubbleOutlineOutlinedIcon
                                className={classes.socialIcons}
                              />
                              1k comm
                            </Button>
                            <Button
                              style={{
                                fontSize: "1.4rem",
                                textTransform: "capitalize",
                                gap: "0.5rem",
                                color: "gray",
                                backgroundColor: "transparent",
                              }}
                            >
                              <ShareOutlinedIcon
                                className={classes.socialIcons}
                              />
                              Share
                            </Button>
                            <Button
                              style={{
                                fontSize: "1.4rem",
                                textTransform: "capitalize",
                                gap: "0.5rem",
                                color: "gray",
                                backgroundColor: "transparent",
                              }}
                            >
                              <SaveOutlinedIcon
                                className={classes.socialIcons}
                              />
                              Save
                            </Button>
                            <Button style={{ backgroundColor: "transparent" }}>
                              <MoreHorizOutlinedIcon
                                className={classes.socialIcons}
                              />
                            </Button>
                          </div>
                        </Paper>
                        <Paper elevation={3} className={classes.leftPaper}>
                          <div>
                            <h2 style={{ margin: "1rem 0rem" }}>
                              Question Heading here
                            </h2>
                          </div>
                          <div
                            style={{
                              display: "block",
                              margin: "2rem 0rem",
                              textDecoration: "none",
                            }}
                          >
                            <p
                              style={{ fontSize: "1.5rem", fontWeight: "700" }}
                            >
                              No answers yet
                            </p>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              margin: "2rem 0 0",
                            }}
                          >
                            <Button
                              style={{
                                fontSize: "1.4rem",
                                textTransform: "capitalize",
                                gap: "0.5rem",
                                color: "gray",
                                backgroundColor: "transparent",
                              }}
                            >
                              <FavoriteBorderOutlinedIcon
                                className={classes.socialIcons}
                              />
                              10k
                            </Button>
                            <Button
                              style={{
                                fontSize: "1.4rem",
                                textTransform: "capitalize",
                                gap: "0.5rem",
                                color: "gray",
                                backgroundColor: "transparent",
                              }}
                            >
                              <ChatBubbleOutlineOutlinedIcon
                                className={classes.socialIcons}
                              />
                              1k comm
                            </Button>
                            <Button
                              style={{
                                fontSize: "1.4rem",
                                textTransform: "capitalize",
                                gap: "0.5rem",
                                color: "gray",
                                backgroundColor: "transparent",
                              }}
                            >
                              <ShareOutlinedIcon
                                className={classes.socialIcons}
                              />
                              Share
                            </Button>
                            <Button
                              style={{
                                fontSize: "1.4rem",
                                textTransform: "capitalize",
                                gap: "0.5rem",
                                color: "gray",
                                backgroundColor: "transparent",
                              }}
                            >
                              <SaveOutlinedIcon
                                className={classes.socialIcons}
                              />
                              Save
                            </Button>
                            <Button style={{ backgroundColor: "transparent" }}>
                              <MoreHorizOutlinedIcon
                                className={classes.socialIcons}
                              />
                            </Button>
                          </div>
                        </Paper>
                      </TabPanel>

                      <TabPanel value="7">
                         <div>
                        <img src={soon} alt="comeing soon" width="500" height="400"/>
                        </div>
                      </TabPanel>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={4}
                      lg={4}
                      style={{ padding: "1rem 0rem 1rem 1rem" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          "& > :not(style)": {
                            m: 1,
                            height: "auto",
                          },
                        }}
                      >
                        <Paper elevation={3} className={classes.rightPaperTop}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={BGImage}
                              alt="BG"
                              style={{ width: "100%", height: "8rem" }}
                            />
                            <IconButton
                              sx={{
                                position: "absolute",
                                right: "3px",
                                top: "3px",
                                background: "#ffffff61",
                                borderRadius: "4px",
                                padding: "3px 2px 5px 6px",
                              }}
                            >
                              <EditSVG
                                style={{ width: "1.8rem", height: "1.8rem" }}
                              />
                            </IconButton>
                          </div>
                          <div style={{ display: "flex" }}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="70"
                              height="70"
                              viewBox="0 0 24 24"
                              style={{
                                margin: "0rem 1rem 0rem 2rem",
                                boxShadow:
                                  "rgba(102, 102, 102, 0.3) 0px 0px 7px 1px",
                                padding: "1rem",
                                borderRadius: "5rem",
                                backgroundColor: "white",
                              }}
                            >
                              <defs>
                                <clipPath id="clip-Profile">
                                  <rect width="24" height="24" />
                                </clipPath>
                              </defs>
                              <g id="Profile" clip-path="url(#clip-Profile)">
                                <path
                                  id="Icon_awesome-evernote"
                                  data-name="Icon awesome-evernote"
                                  d="M5.559,6.84a.855.855,0,0,1-.991.99c-3.162,0-3.378-.046-3.833.153-.026.01-.034,0-.017-.017L5.7,2.906c.017-.017.028-.01.017.017C5.513,3.382,5.559,3.616,5.559,6.84ZM9.182,20.966a2.57,2.57,0,0,1,2.409-3.514.769.769,0,0,1,.365,1.441c-.284.151-1.144.08-1.153.881,0,.784.9,1.147,1.431,1.142a2.093,2.093,0,0,0,2.094-2.094v0a2.674,2.674,0,0,0-2.18-2.538c-.354-.071-2.981-.291-3.135-2.317-.172.777-.8,2.912-1.977,3.169a6.225,6.225,0,0,1-5.179-1.686A4.919,4.919,0,0,1,.561,12.787,22.755,22.755,0,0,1,.05,9.944,1.389,1.389,0,0,1,1.2,8.467c3.715,0,4.128.106,4.632-.358.45-.424.358-.711.358-4.714.046-.381.357-1.413,2.45-1.107a1.868,1.868,0,0,1,1.719,1.405l2.947.511c.937.17,3.254.321,3.7,2.657A37.741,37.741,0,0,1,17.361,17.8c-.733,5.246-5.094,4.992-5.094,4.992a3.444,3.444,0,0,1-3.085-1.827Zm3.712-9.4c-.046.088-.1.275.039.321a6.152,6.152,0,0,0,2.1.254c.143-.011.14-.2.114-.305a1.248,1.248,0,0,0-2.258-.272Z"
                                  transform="translate(2.95 -0.232)"
                                />
                              </g>
                            </svg>

                            <div style={{ margin: "1rem 0rem 0rem" }}>
                              <div>
                                <h3
                                  style={{
                                    fontSize: "1.7rem",
                                    display: "flex",
                                    gap: "5px",
                                  }}
                                >
                                  UID -&gt; <p>{userDetails?.uData?.uid}</p>
                                </h3>
                              </div>
                              <div>
                                <h3
                                  style={{
                                    fontSize: "1.7rem",
                                    display: "flex",
                                    gap: "5px",
                                  }}
                                >
                                  Name -&gt;
                                  <p>{userDetails?.uData?.first_name}</p>
                                </h3>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <h3 style={{ fontSize: "1.7rem" }}>
                                  Rewards -&gt;{" "}
                                </h3>
                                <img
                                  src={CoinsSVG}
                                  alt="Balance Available Coins"
                                  title="Balance Available Coins"
                                  style={{ width: "3rem" }}
                                />
                                <h3 style={{ fontSize: "1.7rem" }}>
                                  {userDetails?.udata?.totalpoints || 0}pts
                                </h3>
                              </div>
                            </div>
                          </div>
                          <div style={{ padding: "1rem" }}>
                            <div
                              style={{
                                alignItems: "center",
                                display: "flex",
                                padding: "1rem 0rem",
                              }}
                            >
                              <AccessTimeIcon
                                style={{
                                  fontSize: "2.5rem",
                                  margin: "0rem 1rem",
                                }}
                              />
                              <p style={{ fontSize: "1.8rem" }}>
                                {userDetails?.uData &&
                                  userDetails.uData.unique_date &&
                                  `Created on ${moment(
                                    userDetails?.uData?.unique_date
                                  ).format("MMM D, YYYY")}`}
                              </p>
                            </div>
                            <div style={{ padding: "1rem 0rem" }}>
                              <Button className={classes.actionButton}>
                                <AddOutlinedIcon /> Add social link
                              </Button>
                            </div>
                            <p style={{ fontSize: "1.5rem" }}>
                              {userDetails?.udata?.Following || 0} Following
                              &#9864; {userDetails?.udata?.Followers || 0}{" "}
                              Followers
                            </p>
                          </div>

                          <div
                            style={{
                              textAlign: "center",
                              padding: "1rem 0rem",
                              borderTop: "1px solid lightgray",
                            }}
                          >
                            <Button
                              className={classes.actionButton}
                              style={{ width: "80%" }}
                              onClick={() =>
                                history.push("/social-learning/create-post")
                              }
                            >
                              <AddCircleOutlineIcon /> New Post
                            </Button>
                          </div>
                        </Paper>
                      </Box>
                    </Grid>
                  </Grid>
                </TabContext>
              </Box>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
export default MyPost;
